module.exports = "/static/assets/d4157dc0bf91a25fd4177a364647132f.png";